import { render, staticRenderFns } from "./footer.vue?vue&type=template&id=4b1e00ee&scoped=true&"
import script from "./footer.vue?vue&type=script&lang=js&"
export * from "./footer.vue?vue&type=script&lang=js&"
import style0 from "./footer.vue?vue&type=style&index=0&lang=css&"
import style1 from "./footer.vue?vue&type=style&index=1&id=4b1e00ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b1e00ee",
  null
  
)

export default component.exports